import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import { languageService } from "../../../Language/language.service";
import moment from "moment";
import { themeService } from "../../../theme/service/activeTheme.service";
import { getIssueMPMethods } from "../../Common/services/mileposts";
import { LocPrefixService } from "../../LocationPrefixEditor/LocationPrefixService";
import { versionInfo } from "../../MainPage/VersionInfo";

function ExecDetail(props) {
  let description = null;
  let startMp = null;
  let endMp = null;
  let comments = null;
  let status = null;
  let information = null;
  let title = null;
  let user = null;
  let m1 = props.m1;
  const selectedRow = props.selectedRowData && props.selectedRowData;

  if (selectedRow) {
    const tasks = props.selectedRowData.tasks;
    status = selectedRow.status;
    title = selectedRow.title;
    console.log(tasks);
    tasks.forEach((t) => {
      t.maintenance.forEach((m) => {
        let startMarker = getIssueMPMethods.getIssueMarkerStart(m1.issue);
        let endMarker = getIssueMPMethods.getIssueMarkerEnd(m1.issue);
        let mExecMPStartPrefix = LocPrefixService.getPrefixMp(m.startMp, m1.lineId);
        let mExecMPEndPrefix = LocPrefixService.getPrefixMp(m.endMp, m1.lineId);
        startMp = m.startMp
          ? `${mExecMPStartPrefix} ${m.startMp}`
          : startMarker || endMarker
            ? startMarker || "N/A"
            : getIssueMPMethods.getIssueFinalStartMP(m1.issue, m1.lineId, true);
        endMp = m.endMp
          ? `${mExecMPEndPrefix} ${m.endMp}`
          : startMarker || endMarker
            ? endMarker || "N/A"
            : getIssueMPMethods.getIssueFinalEndMP(m1.issue, m1.lineId, true);
        comments = m.reportComments;
        information = m.voiceNotes;
      });
      description = m1 && m1.issue && m1.issue.description;
    });
    user = selectedRow.user.name;
  }

  return (
    <div
      style={{
        margin: "0 0 10px 0",
        boxShadow: "rgb(207, 207, 207) 1px 1px 2px",
        padding: "15px",
        textAlign: "left",
        marginBottom: "20px",
      }}
    >
      <Row>
        <Col md={"12"}>
          <div style={props.fieldHeading}>{languageService("MR Number")} :</div>
          <div style={props.fieldText}>{title && title}</div>
        </Col>
        <Col md={"12"}>
          <div style={props.fieldHeading}>{languageService("User")} :</div>
          <div style={props.fieldText}>{user && user}</div>
        </Col>

        <Col md={"12"}>
          <div style={props.fieldHeading}>{languageService("Description")} :</div>
          <div style={props.fieldText}>{description ? description : ""}</div>
        </Col>

        {!versionInfo.isReVAMP() && (
          <Col md={"6"}>
            <div style={{ ...props.fieldHeading, display: "block" }}>{languageService("MP Start")} :</div>
            <div style={props.fieldText}>{startMp ? startMp : ""}</div>
          </Col>
        )}
        {!versionInfo.isReVAMP() && (
          <Col md={"6"}>
            <div style={{ ...props.fieldHeading, display: "block" }}>{languageService("MP End")} :</div>
            <div style={props.fieldText}>{endMp ? endMp : ""}</div>
          </Col>
        )}
        <Col md={"12"}>
          <div style={props.fieldHeading}>{languageService("Status")}: </div>
          <div style={props.fieldText}>{status ? status : ""}</div>
        </Col>
        <Col md={"12"}>
          <div style={props.fieldHeading}>{languageService("Information")} :</div>
          <div style={{ ...props.fieldText, maxWidth: "265px", wordWrap: "break-word" }}>
            {/* <Gravatar style={{ borderRadius: '30px', marginRight: '5px' }} email={'abc@abc.com'} size={20} /> */}
            {information ? information : ""}
          </div>
        </Col>
        {!versionInfo.isReVAMP() && (
          <Col md={"12"}>
            <div style={props.fieldHeading}>{languageService("Comments for Report")} :</div>
            <div style={props.fieldText}>{comments ? comments : ""}</div>
          </Col>
        )}
      </Row>
    </div>
  );
}
export default ExecDetail;



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetail/ExecutionDetail.js